import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getClientId = createAsyncThunk('appCreditNote/getClientId', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetClientList', params, {mode:'cors'})
    return response.data
})

export const updatecreditnote = createAsyncThunk('appCreditNote/updatecreditnote', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/UpdateCreditNote', params, {mode:'cors'})
     
    return {
        data:response.data
    }
  })
  export const gettaxlist = createAsyncThunk('appCreditNote/getTaxList', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetTaxList', params, {mode:'cors'})
    return response.data
})

export const getrefid = createAsyncThunk('appCreditNote/getRefId', async (params) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/GetTableSummaryCreditNote', params, {mode:'cors'})
 
    return response.data
})
export const getCreditNotePDF = createAsyncThunk('appCreditNote/getCreditNotePDF', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/GetCreditNotePDF', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    
    return {
        data: response.data, // JSON from API
      status: response.status
    }
})
export const createcreditnote = createAsyncThunk('appCreditNote/createCreditNote', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/CreateCreditNote', params, {mode:'cors'})
    return response.data
})
export const deletecreditnote = createAsyncThunk('appCreditNote/deleteCreditNote', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/DeleteCreditCard', params, {mode:'cors'})
    return response.data
})

export const getcreditnotelist = createAsyncThunk('appCreditNote/getCreditNoteList', async (params) => {
      
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/AllCreditNotes', params, {mode:'cors'})
    
    return response.data
})

export const editcreditnotelist = createAsyncThunk('appCreditNote/editcreditnotelist', async (params) => {
          
    const response = await axios.post(' https://api.zasway.com:8443/CreditNote/AllCreditNotes', params, {mode:'cors'})
      
    return response.data
})


export const appCreditNoteSlice = createSlice({
    name: 'appCreditNote',
    initialState: {
        data: [],
        editData:[],
        allData: []

    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getClientId.fulfilled, (state, action) => {
                state.allData = action.payload.allData
                state.data = action.payload.data
            })

            .addCase(updatecreditnote.fulfilled, (state, action) => {
                state.data = action.payload.data
            })

    }
})
export default appCreditNoteSlice.reducer